import React, { useRef, useState } from 'react';
import { Form } from 'react-bootstrap';
import { inputValue } from './shippingConfig';
import ShippingSelectOptions from './ShippingSelectOptions';

export default function ShippingEditableCell({ row, column, value, editing, disabled, onBegin, onEnd, onSave, className = '' }) {
  const [draft, setDraft] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const committing = useRef(false);
  const canceled = useRef(false);
  const begin = () => {
    if (disabled || editing) return;
    canceled.current = false;
    setDraft(inputValue(row[column.key], column.type));
    setError('');
    onBegin();
  };
  const commit = async () => {
    if (canceled.current || committing.current || !editing) return;
    committing.current = true;
    setSaving(true);
    setError('');
    try {
      await onSave(draft);
      canceled.current = true;
      onEnd();
    } catch (failure) {
      setError(failure?.data?.message || failure?.message || 'Could not save. Retry or press Escape to cancel.');
    } finally {
      committing.current = false;
      setSaving(false);
    }
  };
  if (!editing) return <td className={`${className} ${disabled ? '' : 'shipping-editable-cell'}`} onDoubleClick={begin} tabIndex={disabled ? undefined : 0} title={disabled ? undefined : 'Double-click or press Enter to edit'} onKeyDown={(event) => {
    if (event.key === 'Enter' || event.key === 'F2') { event.preventDefault(); begin(); }
  }}>{value}</td>;
  const props = {
    autoFocus: true, size: 'sm', value: draft, disabled: saving,
    'aria-label': `${column.label} for ${row.JobNumber}`,
    'aria-invalid': Boolean(error),
    onChange: (event) => setDraft(event.target.value),
    onBlur: commit,
    onKeyDown: (event) => {
      if (event.key === 'Escape' && !committing.current) {
        event.preventDefault(); canceled.current = true; onEnd();
      } else if (event.key === 'Enter' && !(column.type === 'textarea' && event.shiftKey)) {
        event.preventDefault(); commit();
      }
    },
  };
  return <td className="shipping-editing-cell">
    {column.type === 'select' ? <Form.Select {...props}><ShippingSelectOptions column={column} value={draft} /></Form.Select> : <Form.Control {...props} as={column.type === 'textarea' ? 'textarea' : 'input'} type={column.type === 'textarea' ? undefined : column.type} min={column.type === 'number' ? 0 : undefined} step={column.type === 'number' ? 'any' : undefined} />}
    {saving && <small role="status">Saving…</small>}
    {error && <div className="text-danger small" role="alert">{error}</div>}
  </td>;
}
